import React, { useEffect, useRef } from 'react';
import { MagicProvider, useMagic } from './context/MagicContext';
import { Cathedral } from './components/Cathedral';
import { soundManager } from './services/SoundManager';
import './debug-types.d.ts';
import './index.css';

const VerificationPanel = process.env.NODE_ENV === 'development' ? React.lazy(() => import('./dev/DebugPanel')) : null;

// Initialize global debug flags
if (typeof window !== 'undefined') {
  window.__DEBUG_SLOTS__ = window.__DEBUG_SLOTS__ ?? process.env.NODE_ENV === 'development';
  window.__FORCE_ITEMS__ = window.__FORCE_ITEMS__ ?? false;
}

/**
 * AppContent - Main content wrapper
 * Uses MagicContext to determine layout mode
 */
function AppContent() {
  const { activeRealmId } = useMagic();
  const hasUnlocked = useRef(false);

  // Toggle body class for scrollable realms (non-home)
  useEffect(() => {
    window.scrollTo(0, 0);
    if (activeRealmId === 'home') {
      document.body.classList.remove('scrollable-realm');
    } else {
      document.body.classList.add('scrollable-realm');
    }
  }, [activeRealmId]);

  useEffect(() => {
    // Unlock audio on first user interaction (mobile autoplay restriction)
    const unlockAudio = () => {
      if (!hasUnlocked.current) {
        hasUnlocked.current = true;
        soundManager.unlockAudio();
        // Remove listeners after first unlock
        document.removeEventListener('pointerdown', unlockAudio);
        document.removeEventListener('touchstart', unlockAudio);
      }
    };

    document.addEventListener('pointerdown', unlockAudio, { passive: true });
    document.addEventListener('touchstart', unlockAudio, { passive: true });

    return () => {
      document.removeEventListener('pointerdown', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
  }, []);

  return (
    <div className={`sparkle-container ${activeRealmId === 'home' ? 'home-locked' : ''}`}>
      <Cathedral />
      {VerificationPanel && new URLSearchParams(window.location.search).get('verify') === '1' && <React.Suspense fallback={null}><VerificationPanel /></React.Suspense>}
    </div>
  );
}

/**
 * Sparkle World App
 * A magical digital grimoire for young adventurers
 */
function App() {
  return (
    <MagicProvider>
      <AppContent />
    </MagicProvider>
  );
}

export default App;
